import { Module } from '@nestjs/common';
import {UserEntity} from './user.entity';
import {TypeOrmModule} from '@nestjs/typeorm';
import { UserService } from './user.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Module({
  imports: 
    [TypeOrmModule.forFeature([UserEntity])],
  providers: [UserService,ApplicationExceptionHandler],
  exports: [UserService]
})
export class UserModule {}
